import { COLORS } from 'constants/colors';
import styled from 'styled-components';

export const MenuItem = styled.div`
  flex: 1 1 auto;
  margin: 0 20px;
  padding: 3px 0;
  text-align: center;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;
  transition: 0.3s;
  color: ${COLORS.white};

  &:after {
    position: absolute;
    transition: 0.3s;
    content: '';
    width: 0;
    left: 50%;
    bottom: 0;
    height: 2px;
    background: ${COLORS.purple};
    left: 0;
  }

  &:hover {
    cursor: pointer;

    &:after {
      width: 100%;
      left: 0;
    }
  }

  @media only screen and (max-width: 900px) {
    margin: 0 10px;
  }

  @media only screen and (max-width: 650px) {
    font-size: 10px;
    margin: 0 5px;
  }
`;
